import React from 'react';

import { ApolloWrapper } from '@bessemercws/graphql';
import { useClientContext } from '@bessemercws/providers';
import { ErrorProvider } from '@bessemercws/utils';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { AppTheme } from './AppTheme';
import { AppTimeout, Terms } from './components';
import { SplitIOProvider } from './components/SplitProvider/SplitIOProvider';

const App = () => {
  const router = createBrowserRouter([
    { path: '*', element: <AppApollo /> },
    { path: 'terms', element: <Terms /> },
  ]);
  /**
   * Important: RouterProvider needs to be at the top most level to avoid being
   *  rerendered and losing it's context
   */
  return <RouterProvider router={router} />;
};

const AppApollo = () => {
  const { idToken, isAdvisor } = useClientContext();

  return (
    <ApolloWrapper token={idToken} isAdvisor={isAdvisor}>
      <SplitIOProvider>
        <AppTimeout>
          <ErrorProvider>
            <AppTheme />
          </ErrorProvider>
        </AppTimeout>
      </SplitIOProvider>
    </ApolloWrapper>
  );
};

export default App;
